import { crmCustomers as initialCustomers } from '@/mocks';
import type { CrmCustomer } from '@/mocks';

let _customers: CrmCustomer[] = [...initialCustomers];
const _listeners = new Set<() => void>();

function notify() {
  _listeners.forEach(l => l());
}

export const customerStore = {
  getAll: (): CrmCustomer[] => [..._customers],

  add: (customer: Omit<CrmCustomer, 'id'>): CrmCustomer => {
    const newCustomer: CrmCustomer = { ...customer, id: Date.now() };
    _customers = [..._customers, newCustomer];
    notify();
    return newCustomer;
  },

  subscribe: (listener: () => void): (() => void) => {
    _listeners.add(listener);
    return () => { _listeners.delete(listener); };
  },
};
